var map = {
	"./icon-arrow-down.svg": 20,
	"./icon-arrow-left.svg": 21,
	"./icon-arrow-right.svg": 22,
	"./icon-arrow-up-large.svg": 23,
	"./icon-arrow-up.svg": 24,
	"./icon-chevron-down.svg": 25,
	"./icon-close.svg": 26,
	"./icon-email.svg": 27,
	"./icon-facebook.svg": 28,
	"./icon-hart.svg": 29,
	"./icon-instagram.svg": 30,
	"./icon-linkedin.svg": 31,
	"./icon-mail.svg": 32,
	"./icon-marker.svg": 33,
	"./icon-menu.svg": 34,
	"./icon-messenger.svg": 35,
	"./icon-phone.svg": 36,
	"./icon-pinterest.svg": 37,
	"./icon-read-more.svg": 38,
	"./icon-search.svg": 39,
	"./icon-skype.svg": 40,
	"./icon-snapchat.svg": 41,
	"./icon-star.svg": 42,
	"./icon-telegram.svg": 43,
	"./icon-tiktok.svg": 44,
	"./icon-twitter.svg": 45,
	"./icon-vimeo.svg": 46,
	"./icon-whatsapp.svg": 47,
	"./icon-world.svg": 48,
	"./icon-youtube.svg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;